/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAttachAccountLoginMutation($customerId: ID!, $accountId: ID!) {
  CustomerAttachAccountLogin(customerId: $customerId, accountId: $accountId) {
    message
    status
  }
}
`
